function debugCookieExists() {
    return document.cookie.indexOf('debug=true') >= 0;
}

export const trace =
    import.meta.env.DEV || debugCookieExists()
        ? // biome-ignore lint/suspicious/noExplicitAny: suppress out of convenience during migration to biome
          (...args: any) => {
              console.log('[debug]', ...args);
          }
        : () => {};
